import { 
  Type, 
  Hash, 
  Code, 
  Binary, 
  Sparkles, 
  TextCursorInput, 
  Quote, 
  Braces,
  Settings,
  Lock,
  FileJson,
  RefreshCw,
  Search,
  Scale,
  Palette,
  QrCode,
  Clock,
  Scissors,
  Maximize2,
  ListRestart,
  Link2
} from 'lucide-react';
import { Tool, Category } from './types';

export const CATEGORIES: Category[] = [
  { id: 'text', name: 'Text & Content' },
  { id: 'dev', name: 'Developers' },
  { id: 'ai', name: 'AI Tools' },
  { id: 'design', name: 'Design' },
  { id: 'seo', name: 'SEO' },
  { id: 'utilities', name: 'Utilities' },
];

export const TOOLS: Tool[] = [
  {
    id: 'word-counter',
    name: 'Word & Character Count',
    description: 'Real-time word and character counting with paragraph analysis.',
    icon: Type,
    category: 'text',
    path: '/tools/word-counter',
  },
  {
    id: 'case-converter',
    name: 'Case Converter',
    description: 'UPPERCASE, lowercase, Title Case, camelCase, snake_case.',
    icon: TextCursorInput,
    category: 'text',
    path: '/tools/case-converter',
  },
  {
    id: 'json-formatter',
    name: 'JSON Formatter',
    description: 'Clean, format, and validate JSON data instantly.',
    icon: FileJson,
    category: 'dev',
    path: '/tools/json-formatter',
  },
  {
    id: 'base64-converter',
    name: 'Base64 Converter',
    description: 'Encode and decode strings to and from Base64.',
    icon: Binary,
    category: 'dev',
    path: '/tools/base64-converter',
  },
  {
    id: 'hash-generator',
    name: 'Hash Generator',
    description: 'Generate MD5 and SHA-256 hashes for any text.',
    icon: Hash,
    category: 'dev',
    path: '/tools/hash-generator',
  },
  {
    id: 'qr-generator',
    name: 'QR Code Generator',
    description: 'Generate high-quality QR codes for links, text, or Wi-Fi.',
    icon: QrCode,
    category: 'utilities',
    path: '/tools/qr-generator',
  },
  {
    id: 'unix-timestamp',
    name: 'Unix Timestamp',
    description: 'Convert Unix timestamps to human dates and vice versa.',
    icon: Clock,
    category: 'dev',
    path: '/tools/unix-timestamp',
  },
  {
    id: 'minifier',
    name: 'Code Minifier',
    description: 'Minify CSS and JS code to reduce file size and improve performance.',
    icon: Scissors,
    category: 'dev',
    path: '/tools/minifier',
  },
  {
    id: 'px-to-rem',
    name: 'PX to REM Converter',
    description: 'Convert pixels to REM/EM based on base font size.',
    icon: Maximize2,
    category: 'dev',
    path: '/tools/px-to-rem',
  },
  {
    id: 'ai-rewriter',
    name: 'AI Smart Rewriter',
    description: 'Improve tone, clarity, and impact of your text using AI.',
    icon: Sparkles,
    category: 'ai',
    path: '/tools/ai-rewriter',
  },
  {
    id: 'password-gen',
    name: 'Password Generator',
    description: 'Create secure, unbreakable passwords with custom rules.',
    icon: Lock,
    category: 'utilities',
    path: '/tools/password-gen',
  },
  {
    id: 'unit-converter',
    name: 'Unit Converter',
    description: 'Convert length, weight, temperature, and volume instantly.',
    icon: Scale,
    category: 'utilities',
    path: '/tools/unit-converter',
  },
  {
    id: 'color-picker',
    name: 'Color Picker',
    description: 'Explore colors, generate palettes, and convert formats (HEX, RGB).',
    icon: Palette,
    category: 'utilities',
    path: '/tools/color-picker',
  },
  {
    id: 'lorem-ipsum',
    name: 'Lorem Ipsum Gen',
    description: 'Generate professional placeholder text for your designs.',
    icon: Quote,
    category: 'utilities',
    path: '/tools/lorem-ipsum',
  },
  {
    id: 'duplicate-remover',
    name: 'Duplicate Remover',
    description: 'Clean up lists by removing duplicates and sorting entries.',
    icon: ListRestart,
    category: 'text',
    path: '/tools/duplicate-remover',
  },
  {
    id: 'url-encoder',
    name: 'URL Encoder / Decoder',
    description: 'Safely encode or decode URLs and text with special characters.',
    icon: Link2,
    category: 'dev',
    path: '/tools/url-encoder',
  },
  {
    id: 'text-to-slug',
    name: 'Text to Slug Converter',
    description: 'Convert titles and text into SEO-friendly URLs and routes.',
    icon: Type,
    category: 'seo',
    path: '/tools/text-to-slug',
  },
  {
    id: 'gradient-generator',
    name: 'CSS Gradient Generator',
    description: 'Create and customize beautiful CSS gradients visually.',
    icon: Palette,
    category: 'design',
    path: '/tools/gradient-generator',
  }
];
